import ProductCard from './ProductCard';
import './ProductCard.scss';

export default ProductCard;
